import React from 'react';

import UserLoginForm from './UserLoginForm.jsx';
import Divider from './Divider.jsx';

import { defaultApp } from '../utils/firebase';

import {
    MAX_COMMENT_SIZE,
    MODE_DEFAULT,
    MODE_EDIT,
    MODE_REPLY
} from '../utils/constants';

import './CommentForm.css';

class CommentForm extends React.Component {

    static defaultProps = {
        mode: MODE_DEFAULT
    };

    textArea = React.createRef();

    state = {
        body: this.props.body || '',
        commentInProgress: false,
        showLogin: false
    };

    componentDidMount() {

        if (this.props.mode !== MODE_DEFAULT) {
            this.textArea.current.focus();
        }
    }

    componentDidUpdate() {
        this.props.sendResizeEvent();
    }

    onChangeBody = ({ currentTarget: { value: body } }) => {

        this.textArea.current.style.height = 'auto';
        this.textArea.current.style.height = `${this.textArea.current.scrollHeight}px`;

        this.setState({ body });
    };

    onChangeAnonymous = () => {

        this.props.changeUserPreferences({ anonymous: !this.props.userPreferences.anonymous });
    };

    onChangeSubscribe = () => {

        this.props.changeUserPreferences({ subscribe: !this.props.userPreferences.subscribe });
    };

    onLogout = () => {

        this.props.logout();
    };

    onShowLogin = e => {

        this.setState({ showLogin: true }, () => {

            this.props.getUser()
                .then(this.afterLogin)
                .catch(this.afterLogin);
        });
    };

    onComment = e => {

        e.preventDefault();

        this.setState({ commentInProgress: true }, () => {

            this.postComment().then(this.afterComment).catch(this.afterComment);
        });
    };

    onSendEmailVerification = e => {

        defaultApp.auth().currentUser.sendEmailVerification({
            url: 'https://app.commentbox.io?redirect='+encodeURIComponent(this.props.url)
        });
    };

    postComment = () => {

        switch (this.props.mode) {
            case MODE_DEFAULT:
                return this.props.postComment(this.state.body);
            case MODE_EDIT:
                return this.props.editComment(this.state.body, this.props.commentId);
            case MODE_REPLY:
                return this.props.postComment(this.state.body, this.props.commentId);
            default:
                throw new Error('not a valid state');
        }
    };

    afterLogin = () => {

        this.setState({ showLogin: false });
    };

    afterComment = () => {

        this.setState({
            body: '',
            commentInProgress: false
        }, () => {

            if (this.props.commentId) {
                this.props.onCancel({ currentTarget: { value: this.props.onCancelValue } });
            }

        });
    };

    get cancelButton() {

        if (!this.props.onCancel) {
            return null;
        }

        return (
            <button
                type="button"
                className="btn secondary-button"
                onClick={this.props.onCancel}
                value={this.props.onCancelValue}
            >
                Cancel
            </button>
        );
    }

    get emailVerification() {

        const {
            userPreferences: {
                subscribe
            }
        } = this.props;

        const user = defaultApp.auth().currentUser;

        if (user
            && user.providerData.length === 1
            && user.providerData[0].providerId === 'password'
            && !user.emailVerified
        ) {

            return (
                <div className="email-verification">
                    <p>
                        Before commenting, you'll have to confirm your email address by opening the link we sent to <strong>{defaultApp.auth().currentUser.email}</strong>.
                    </p>
                    <p>
                        Didn't get an email? <Divider />  <button type="button" onClick={this.onSendEmailVerification}><span className="icon-exit_to_app" /> send another</button>
                    </p>
                </div>
            );
        }

        if (!subscribe || !user || user.emailVerified) {
            return null;
        }


        return (
            <div className="email-verification">
                <p>
                    Before receiving any replies, you'll have to confirm your email address by opening the link we sent to <strong>{defaultApp.auth().currentUser.email}</strong>.
                </p>
                <p>
                    Didn't get an email? <Divider />  <button type="button" onClick={this.onSendEmailVerification}><span className="icon-exit_to_app" /> send another</button>
                </p>
            </div>
        );
    }

    get logoutOption() {

        const {
            userId,
            userDisplayName,
            subtextColor,
            userPreferences: {
                anonymous
            }
        } = this.props;

        const style = {};

        if (subtextColor) {
            style.color = subtextColor;
        }

        if (userId) {

            return (
                <div style={style} className="logout">
                    <p>
                        Posting as <span className="display-name">{userDisplayName}{anonymous ? ' (Anonymous)' : ''}</span> <Divider /> <button type="button" onClick={this.onLogout}><span className="icon-exit_to_app" /> log out</button>
                    </p>
                </div>
            );
        }

        return (
            <div style={style} className="logout">
                <p>
                    Please sign in to create comments.
                </p>
            </div>
        );
    }

    render() {

        if (this.state.showLogin && this.props.onUser) {
            return (
                <UserLoginForm
                    {...this.props}
                    close={this.props.onUser.reject}
                    authUiConfig={this.props.authUiConfig}
                />
            );
        }

        const {
            page,
            userId,
            mode,
            userIsBlocked,
            userPageProfile: {
                comments
            },
            userPreferences: {
                anonymous,
                subscribe
            }
        } = this.props;

        const { body, commentInProgress } = this.state;
        const user = defaultApp.auth().currentUser;

        let cantComment = userIsBlocked && (!userIsBlocked.until || userIsBlocked.until > Date.now());
        let enabled = body.length > 0 && !commentInProgress && !cantComment;

        let placeholder = 'Leave a comment';
        let buttonText = 'Post Comment';

        if (cantComment) {
            placeholder = 'You have been blocked';
            if (userIsBlocked.until) {
                placeholder+= ' for a limited time';
            }
        }
        if (user
            && user.providerData.length === 1
            && user.providerData[0].providerId === 'password'
            && !user.emailVerified) {
            enabled = false;
        }

        switch (mode) {
            case MODE_DEFAULT:

                if (Object.keys(comments).length >= 100) {
                    cantComment = true;
                    placeholder = 'You have reached the comment limit';
                }

                break;
            case MODE_REPLY:
                placeholder = 'Reply to this comment';
                buttonText = 'Post Reply';
                if (Object.keys(comments) >= 100) {

                }
                break;
            case MODE_EDIT:
                placeholder = 'Edit this comment';
                buttonText = 'Post Edit';
                break;
        }

        if (page.status) {
            cantComment = true;
            enabled = false;
            placeholder = `This thread is ${page.status}`;
        }

        return (
            <div className="comment-form">
                <form onSubmit={this.onComment}>

                    <div className="body">

                        <div className="textarea-container">
                            <textarea
                                ref={this.textArea}
                                disabled={commentInProgress || cantComment}
                                placeholder={placeholder}
                                maxLength={MAX_COMMENT_SIZE}
                                value={this.state.body}
                                onChange={this.onChangeBody}
                            />
                        </div>

                    </div>

                    <div className="footer">

                        <div style={userId ? null: { display: 'none' }} className={`options${enabled ? ' active' : ''}`}>
                            <label><input
                                type="checkbox"
                                onChange={this.onChangeAnonymous}
                                value={anonymous}
                                checked={!!anonymous}
                                disabled={!enabled}
                            />
                                <span className="icon-person" /> anonymous
                            </label>
                            <label><input
                                type="checkbox"
                                onChange={this.onChangeSubscribe}
                                value={subscribe}
                                checked={!!subscribe}
                                disabled={!enabled}
                            />
                                <span className="icon-notifications_active"/> email replies
                            </label>
                        </div>

                        {userId ? (
                            <button
                                type="submit"
                                className={`btn primary-button${commentInProgress ? ' busy' : ''}`}
                                disabled={!enabled || cantComment}
                            >
                                {(commentInProgress) ? 'Posting...' : buttonText}
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn primary-button"
                                onClick={this.onShowLogin}
                            >
                                Sign In
                            </button>
                        )}

                        {this.cancelButton}

                    </div>
                    {this.emailVerification}
                    {this.logoutOption}

                </form>
            </div>
        );
    }
}

export default CommentForm;


// WEBPACK FOOTER //
// ./src/components/CommentForm.jsx